import { render, staticRenderFns } from "./BinaryType.vue?vue&type=template&id=398fdbb0&"
import script from "./BinaryType.vue?vue&type=script&lang=ts&"
export * from "./BinaryType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports